import { oauthProviderClient } from '@better-auth/oauth-provider/client';
import { customSessionClient, inferAdditionalFields } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import type { Auth } from 'server/services/betterAuthService';

/**
 * better-auth browser client. Same-origin as the API (prod: one server; dev: Vite proxies
 * `/api` to the backend), so the session cookie is sent automatically - no token handling.
 */
export const authClient = createAuthClient({
    baseURL: window.location.origin,
    plugins: [inferAdditionalFields<Auth>(), customSessionClient<Auth>(), oauthProviderClient()],
});

export default authClient;
